import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getPublications = store => store[NAME].publications;
export const getTypes = store => store[NAME].types;
export const getWorkflows = store => store[NAME].workflows;
export const getCodes = store => store[NAME].codes;
